import React, { useState, useEffect } from 'react';

const AD_LIST = [
  { name: '協和運輸倉庫', image: '/ads/kyowa.png', url: 'https://www.kyowa-unyu-soko.co.jp' },
  { name: '白石倉庫', image: '/ads/shiroishi.png', url: 'https://www.shiroishi.co.jp' },
  { name: '大昇物流', image: '/ads/daisyo.png', url: 'http://daisyo-s.co.jp' },
  { name: '三信倉庫', image: '/ads/sanshin.png', url: 'https://www.loop-mx.co.jp' },
  { name: 'ダイワコーポレーション', image: '/ads/daiwacorp.png', url: 'https://daiwacorporation.co.jp' },
  { name: '髙取ロジスティクス', image: '/ads/takatori.png', url: 'https://www.takatori.tokyo' },
];
const DISPLAY_INTERVAL = 8000;

export default function Footer() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % AD_LIST.length);
    }, DISPLAY_INTERVAL);
    return () => clearInterval(timer);
  }, []);

  const currentAd = AD_LIST[index];

  return (
    <div id="footer-dengendonor">
      <div className="footer-content">
        <a
          href={currentAd.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            key={currentAd.url}
            src={currentAd.image}
            alt={currentAd.name}
          />
        </a>
      </div>
    </div>
  );
}